var _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    gradientTransform: "matrix(1 0 0 -1 0 -15158)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 512,
    y1: -15414,
    y2: -15414
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#08424f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#08424f",
    offset: 0.231
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#08424f",
    offset: 0.5138
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#08424f",
    offset: 0.7915057915057915
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#08424f",
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
    fill: "url(#a)",
    "data-original": "url(#a)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m287.355469 256c0 16.882812-13.6875 30.570312-30.570313 30.570312-16.886718 0-30.574218-13.6875-30.574218-30.570312s13.6875-30.570312 30.574218-30.570312c16.882813 0 30.570313 13.6875 30.570313 30.570312zm0 0",
    fill: "#ffffff",
    "data-original": "#ffffff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.785156 344.6875c-48.902344 0-88.6875-39.785156-88.6875-88.6875s39.785156-88.6875 88.6875-88.6875 88.683594 39.785156 88.683594 88.6875-39.78125 88.6875-88.683594 88.6875zm0-147.375c-32.359375 0-58.6875 26.328125-58.6875 58.6875s26.328125 58.6875 58.6875 58.6875 58.6875-26.328125 58.6875-58.6875-26.328125-58.6875-58.6875-58.6875zm0 0",
    fill: "#ffffff",
    "data-original": "#ffffff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.34375 407.398438c-40.753906 0-81.070312-14.609376-119.832031-43.417969-38.316407-28.480469-61.9375-61.175781-70.316407-73.914063-13.613281-20.695312-13.613281-47.4375 0-68.132812 8.378907-12.738282 32-45.4375 70.316407-73.914063 38.761719-28.808593 79.078125-43.417969 119.832031-43.417969 40.808594 0 81.089844 14.644532 119.726562 43.535157 38.144532 28.519531 61.578126 61.261719 69.882813 74.011719 13.390625 20.5625 13.390625 47.136718 0 67.703124-4.519531 6.941407-13.8125 8.90625-20.753906 4.382813-6.941407-4.519531-8.90625-13.8125-4.386719-20.753906 6.917969-10.621094 6.917969-24.339844 0-34.960938-25.132812-38.597656-88.058594-103.917969-164.46875-103.917969s-139.71875 65.257813-165.082031 103.816407c-7.027344 10.679687-7.027344 24.480469 0 35.160156 25.363281 38.5625 88.671875 103.820313 165.082031 103.820313 52.933594 0 96.648438-30.59375 124-56.257813 6.042969-5.667969 15.535156-5.367187 21.203125.671875 5.667969 6.042969 5.367187 15.535156-.671875 21.203125-31.304688 29.371094-81.785156 64.382813-144.53125 64.382813zm0 0",
    fill: "#ffffff",
    "data-original": "#ffffff",
    style: {}
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.c62ab480d1f747e6505b4e82f2ec9351.svg";
export { ForwardRef as ReactComponent };